import React from 'react';
import RxOrderContainer from "../../containers/RxOrder";

interface Props {
    meganetColorDensityMappingId: number | undefined,
}

export default ((props) => {

    const rxOrderContainer = RxOrderContainer.useContainer();
    const color = rxOrderContainer.getColorByColorDensityMappingId(props.meganetColorDensityMappingId);


    return (
        <>
            {color ? `${color.denTop}${color.denBottom !== null ? '/' + color.denBottom : ''}` : '--'}
        </>
    );
}) as React.FC<Props>;
